import React from 'react';
import PropTypes from 'prop-types';
import { Errors } from 'react-redux-form/immutable';

export const RadioGroup = (props) => {
  const { children, model } = props;
  return (
    <div className="form-group">
      <div role="radiogroup">
        {children}
      </div>
      <Errors
        model={model}
        component="div"
        wrapper={({ children: childs }) => <div className="invalid-feedback">{childs}</div>}
      />
    </div>
  );
};

RadioGroup.propTypes = {
  model: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};
